import { render, staticRenderFns } from "./BottomWrap.vue?vue&type=template&id=65c78fb0&scoped=true"
import script from "./BottomWrap.vue?vue&type=script&lang=js"
export * from "./BottomWrap.vue?vue&type=script&lang=js"
import style0 from "./BottomWrap.vue?vue&type=style&index=0&id=65c78fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c78fb0",
  null
  
)

export default component.exports